// React Query keys
export const TEAM_LIST_QUERY_KEYS = {
  CARERS: 'carers'
} as const
